export const checkPathCondition = (path, location) => {
  let value = path.value || '';

  switch (path.operator.value) {
    case '=':
      return value.toLowerCase() === location.toLowerCase();
    case '<>':
      return value.toLowerCase !== location.toLowerCase();
    case 'LIKE':
      return location.toLowerCase().indexOf(value.toLowerCase()) >= 0;
    case 'NOT LIKE':
      return location.toLowerCase().indexOf(value.toLowerCase()) < 0;
  };
};

export const checkGeneralCondition = (path, skipAdvanced) => {
  const query = location.search;
  const hash = location.hash;
  switch (path.name) {
    case 'query':
      if (skipAdvanced) return false;
      return checkPathCondition(path, query);
    case 'hash':
      if (skipAdvanced) return false;
      return checkPathCondition(path, hash);
    case 'path':
      return checkPathCondition(path, location.pathname);
    case 'domain':
      return checkPathCondition(path, location.hostname);
    default:
      return true;
  }
};



/** WEBPACK FOOTER **
 ** ./src/utils/pathUtils.js
 **/